var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 382.674,
    height: 94.22,
    viewBox: "0 0 382.674 94.22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.302,
    y1: -0.256,
    x2: 0.821,
    y2: 1.808,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.383,
    stopColor: "#71beef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#6dbbec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.619,
    stopColor: "#499ad5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.735,
    stopColor: "#3b8ecc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.173,
    y1: 0.045,
    x2: 0.854,
    y2: 1.073,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.154,
    stopColor: "#adff2f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.264,
    stopColor: "#a7f72c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.766,
    stopColor: "#91d821"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0f7158"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2f9e65"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2b9b64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#71d26f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4ebf76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8be069"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#85df69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#89e06c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.467,
    stopColor: "#95e575"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.707,
    stopColor: "#aaec84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.948,
    stopColor: "#c6f79a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cefaa0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: -0.137,
    y1: 0.499,
    x2: 0.862,
    y2: 0.501,
    xlinkHref: "#linear-gradient-7"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4007",
    "data-name": "Group 4007",
    transform: "translate(-90.655 -294.457)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2294",
    "data-name": "Group 2294",
    transform: "translate(90.656 294.457)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2290",
    "data-name": "Group 2290"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4531",
    "data-name": "Path 4531",
    d: "M131.824,315.02a18.6,18.6,0,0,0-10.832-11.686,18.651,18.651,0,0,1,12.654,9.37c1.514-3.472.007-7.4-2.322-10.059-8.613-9.834-22.139-9.211-29.373-6.333-7.577,3.014-13.94,9.207-10.185,9.207,16.621,0,24.71,8.8,30.277,10.5C127.11,317.573,130.35,316.054,131.824,315.02Z",
    transform: "translate(-90.656 -294.457)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4532",
    "data-name": "Path 4532",
    d: "M116.211,302.674a20.24,20.24,0,0,1,7.577,1.463,18.673,18.673,0,0,1,8.853,6.925q.552.761,1.033,1.574c1.465-3.456-.035-7.35-2.349-9.991-8.613-9.834-22.139-9.211-29.373-6.333-7.577,3.014-13.94,9.207-10.185,9.207a41.879,41.879,0,0,1,11.746,1.621A20.2,20.2,0,0,1,116.211,302.674Z",
    transform: "translate(-90.656 -294.457)",
    fill: "url(#linear-gradient-2)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2291",
    "data-name": "Group 2291",
    transform: "translate(20.259 23.059)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4533",
    "data-name": "Path 4533",
    d: "M163.443,363.656q-10.767,0-16.126,6.369-4.327,5.078-4.327,13.641,0,8.649,4.327,13.727,5.26,6.454,16.126,6.455,10.963,0,16.174-6.455,4.228-5.077,4.228-13.727,0-8.478-4.228-13.641Q174.405,363.657,163.443,363.656Zm0,33.135q-10.867,0-10.866-13.125,0-12.954,10.866-12.954,11.062,0,11.061,12.954Q174.5,396.791,163.443,396.791Z",
    transform: "translate(-142.99 -359.927)",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4534",
    "data-name": "Path 4534",
    d: "M393.338,487.714a4.237,4.237,0,0,0-3.206,1.334,4.459,4.459,0,0,0-1.269,3.185,4.536,4.536,0,0,0,1.269,3.206,4.207,4.207,0,0,0,3.206,1.355,4.459,4.459,0,0,0,3.227-1.355,4.352,4.352,0,0,0,1.377-3.206,4.281,4.281,0,0,0-1.377-3.185A4.492,4.492,0,0,0,393.338,487.714Z",
    transform: "translate(-293.682 -435.96)",
    fill: "url(#linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4535",
    "data-name": "Path 4535",
    d: "M423.8,487.714a4.273,4.273,0,0,0-3.163,1.334,4.38,4.38,0,0,0-1.313,3.185,4.454,4.454,0,0,0,1.313,3.206,4.243,4.243,0,0,0,3.163,1.355,4.457,4.457,0,0,0,3.227-1.355,4.354,4.354,0,0,0,1.377-3.206,4.283,4.283,0,0,0-1.377-3.185A4.49,4.49,0,0,0,423.8,487.714Z",
    transform: "translate(-312.35 -435.96)",
    fill: "url(#linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4536",
    "data-name": "Path 4536",
    d: "M358.867,360.119q-9.165,0-13.469,5.939-3.615,5.079-3.615,13.038v2.8q0,8.822-8.65,8.822h-6.068q-8.737,0-8.736-8.736V358.443c.005-.087.013-.173.013-.261a4.159,4.159,0,1,0-8.275.571v22.968q0,8.995-8.822,8.994h-13.3q.085-3.357.129-6.046t.043-4.712q0-20.612-16.826-20.612-8.995,0-13.684,6.54-3.873,5.466-3.873,14.072,0,7.962,4.476,12.694,4.777,5.123,13.684,5.293h6.885a11.562,11.562,0,0,1-3.335,6.735,10.222,10.222,0,0,1-6.993,2.862c-4.152.2-7.364-.624-12.39-2.592l-.007,0-.224-.087v0a4.175,4.175,0,1,0-2.408,7.985c2.91,1.253,10.524,2.646,14.906,2.451,6.26-.278,9.745-1.824,13.1-5.238,3.069-2.984,4.953-7.241,5.7-12.118h14.631q8.046,0,12.522-4.691,4.518,4.692,12.264,4.691h7.1q8.736,0,12.953-4.691,4.69,4.692,12.264,4.691,8.993,0,13.383-5.981,3.615-4.949,3.615-12.867,0-7.96-3.615-13.038Q367.947,360.118,358.867,360.119Zm-79.223,30.6H271.9q-9.769,0-9.769-10.758,0-13.3,9.166-13.3,5.464,0,7.315,4.389,1.12,2.669,1.119,8.907Zm79.223.086q-8.736,0-8.736-11.705,0-11.834,8.736-11.833,8.65,0,8.65,11.833Q367.517,390.8,358.867,390.8Z",
    transform: "translate(-208.734 -354.023)",
    fill: "url(#linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4537",
    "data-name": "Path 4537",
    d: "M711.932,492.232a4.312,4.312,0,0,0-1.356-3.185,4.418,4.418,0,0,0-3.206-1.334,4.306,4.306,0,0,0-3.227,1.334,4.42,4.42,0,0,0-1.291,3.185,4.5,4.5,0,0,0,1.291,3.206,4.275,4.275,0,0,0,3.227,1.355,4.63,4.63,0,0,0,4.562-4.561Z",
    transform: "translate(-486.122 -435.96)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4538",
    "data-name": "Path 4538",
    d: "M722.686,514.171a4.527,4.527,0,0,0-3.228,1.312,4.308,4.308,0,0,0-1.377,3.249,4.7,4.7,0,0,0,4.6,4.6,4.215,4.215,0,0,0,3.163-1.377,4.53,4.53,0,0,0,1.312-3.227,4.416,4.416,0,0,0-1.312-3.249A4.314,4.314,0,0,0,722.686,514.171Z",
    transform: "translate(-495.456 -452.176)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4539",
    "data-name": "Path 4539",
    d: "M737.9,487.714a4.276,4.276,0,0,0-3.163,1.334,4.381,4.381,0,0,0-1.313,3.185,4.456,4.456,0,0,0,1.313,3.206,4.246,4.246,0,0,0,3.163,1.355,4.46,4.46,0,0,0,3.228-1.355,4.354,4.354,0,0,0,1.377-3.206,4.282,4.282,0,0,0-1.377-3.185A4.493,4.493,0,0,0,737.9,487.714Z",
    transform: "translate(-504.857 -435.96)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4540",
    "data-name": "Path 4540",
    d: "M889.188,370.289h-.069c0-.047.008-.094.008-.141a4.1,4.1,0,0,0-8.176,0,3.5,3.5,0,0,0,.031.449v16.412a15.973,15.973,0,0,1-.378,4.086,10.6,10.6,0,0,1-1.282,3.272,5.558,5.558,0,0,1-1.706,1.747,4.9,4.9,0,0,1-2.146.751,5.109,5.109,0,0,1-.523.027,5.845,5.845,0,0,1-1.817-.3,7.212,7.212,0,0,1-2.315-1.311,9.565,9.565,0,0,1-2.241-2.647,11.131,11.131,0,0,1-1.123-2.926,17.211,17.211,0,0,1-.411-3.056c-.045-1.011-.067-2.049-.067-3.083l.033-13.274h-.016a3.594,3.594,0,0,0,.025-.415,4.146,4.146,0,0,0-8.269,0,3.58,3.58,0,0,0,.025.415h0v16.279a20.571,20.571,0,0,1-.188,2.823,14.717,14.717,0,0,1-.6,2.592,8.12,8.12,0,0,1-1.256,2.36,7.868,7.868,0,0,1-1.852,1.743,6.439,6.439,0,0,1-2.361.994,5.169,5.169,0,0,1-1.017.1,5.594,5.594,0,0,1-1.6-.24,6.112,6.112,0,0,1-2.564-1.642,9.023,9.023,0,0,1-1.86-2.694,13.155,13.155,0,0,1-.912-2.982,21.48,21.48,0,0,1-.324-3.09c-.034-1.029-.051-2.029-.051-2.97V370.289h-.014c.008-.1.016-.19.016-.288a4.125,4.125,0,0,0-8.227,0c0,.1.008.192.015.288h-.028V388.07a11.929,11.929,0,0,1-1.107,4.657,10.33,10.33,0,0,1-2.494,3.3,7.692,7.692,0,0,1-3.61,1.835c-1.329.227-14.912.209-14.912.209l0,.014H806.31q.085-3.357.129-6.046t.043-4.712q0-20.612-16.826-20.612-8.995,0-13.684,6.54-3.873,5.466-3.873,14.072,0,7.962,4.476,12.694,4.777,5.123,13.685,5.293h6.885a11.566,11.566,0,0,1-3.335,6.735,11.27,11.27,0,0,1-7.4,2.882,21.208,21.208,0,0,1-11.132-2.234l-.006.015a4.176,4.176,0,1,0-2.937,7.767c4.659,1.976,10.191,2.16,14.541,2.16a17.756,17.756,0,0,0,12.89-5.534,20.154,20.154,0,0,0,5.723-11.791h9.146v0l.478,0h.789V405.3c3.322-.038,10.336-.159,11.577-.2a18.433,18.433,0,0,0,4.924-.976,20.307,20.307,0,0,0,7.489-4.688l.206-.2.2.206a23.188,23.188,0,0,0,6.229,4.714,11.713,11.713,0,0,0,5.015,1.229c.2,0,.4-.006.6-.019a11.655,11.655,0,0,0,5.288-1.727,27.242,27.242,0,0,0,5.211-4.2l.205-.208.206.206a18.62,18.62,0,0,0,5.8,4.069,14.583,14.583,0,0,0,5.715,1.237h.192a13.321,13.321,0,0,0,5.518-1.276,14.224,14.224,0,0,0,4.6-3.465,16.833,16.833,0,0,0,3.142-5.365,20.038,20.038,0,0,0,1.16-6.968c0-3.023.005-5.989.017-8.816C889.214,376.051,889.209,373.17,889.188,370.289ZM798,398.08h-7.746q-9.77,0-9.769-10.758,0-13.3,9.166-13.3,5.465,0,7.315,4.389,1.12,2.669,1.119,8.907Z",
    transform: "translate(-526.795 -361.387)",
    fill: "url(#linear-gradient-10)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4541",
    "data-name": "Path 4541",
    d: "M641.416,356.511a4.141,4.141,0,0,0-4.13,4.686h-.009v21.781c0,6-2.893,8.874-8.716,8.874l-4.237-.027V391.8H611.888V360.177h-.008a4.18,4.18,0,0,0-8.36.079c0,.129.008.257.019.382v36.2q0,5.552-3.055,8.757a10.341,10.341,0,0,1-7.717,3.242,27.853,27.853,0,0,1-11.664-2.487,4.157,4.157,0,0,0-.511-.221l-.109-.047,0,.006a4.178,4.178,0,1,0-2.6,7.942c2.638,1.557,10.468,2.459,14.142,2.464,6.337.008,10.307-1.918,13.75-5A18.645,18.645,0,0,0,611.8,399.2h17.212q7.489,0,12.05-4.389a14.839,14.839,0,0,0,4.518-11.188v-22.71h-.012c0-.079.012-.157.012-.237A4.166,4.166,0,0,0,641.416,356.511Z",
    transform: "translate(-407.766 -355.28)",
    fill: "url(#linear-gradient-11)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.78448b0bff5140bc0c24427238c63775.svg";
export { ForwardRef as ReactComponent };